const options = {
  locale: "es-MX",
  prefix: "$",
  suffix: "",
  length: 11,
  precision: 2,
};

export default options;
